import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Tab,
  Tabs,
} from "@material-ui/core";
import React from "react";
import { toast, ToastContainer } from "react-toastify";
import { IEmittedDoc } from "src/domain/models/Emitted";
import Cards from "react-credit-cards";
import { InputLetter, InputNumber, InputText } from "../input";
import { useForm } from "src/infrastructure/hooks/useForm";
import { RTextField } from "src/components/ratifikaElements";
import logoOpenpay from "../../assets/imgs/logoopenpay.jpg";
import "react-credit-cards/es/styles-compiled.css";
import TextStyle from "../textStyle";
import { ButtonPrimary } from "../button";
import {
  getCurrencySymbol,
  getCurrentDate,
} from "src/infrastructure/static/util";
import { Colors } from "src/infrastructure/static/colors";
import { paymentService } from "src/domain/services/Payment.service";
import { validatorPaymentForm } from "src/infrastructure/static/validations";
import moment from "moment";

interface IModalPaymentProps {
  open: boolean;
  onClose: () => void;
  infoFile: IEmittedDoc;
  companyInfo: any;
  getData: () => void;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box /* style={{ p: 3 }} */>
          <TextStyle type="h3" bold={400}>
            {children}
          </TextStyle>
        </Box>
      )}
    </div>
  );
}

const ModalPayment: React.FC<IModalPaymentProps> = ({
  open,
  onClose,
  infoFile,
  companyInfo,
  getData,
}) => {
  function a11yProps(index: number) {
    return {
      id: `scrollable-auto-tab-${index}`,
      "aria-controls": `scrollable-auto-tabpanel-${index}`,
    };
  }

  const [valueTab, setValueTab] = React.useState(0);
  const [focus, setFocus] = React.useState<any>();
  const [loading, setLoading] = React.useState(false);
  const { form, onChange, onCompleteData } = useForm({
    cardName: "",
    cardCVC: "",
    cardNumber: "",
    cardExpiry: "",
  });

  const {
    form: formError,
    onChangeError,
    onReset,
  } = useForm({
    cardNameError: false,
    cardNameErrorText: "",
    cardCVCError: false,
    cardCVCErrorText: "",
    cardNumberError: false,
    cardNumberErrorText: "",
    cardExpiryError: false,
    cardExpiryErrorText: "",
  });

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValueTab(newValue);
  };

  const [openModal, setOpenModal] = React.useState(open);

  const handleKeyboardEvent = (
    event: React.KeyboardEvent<HTMLImageElement>
  ) => {
    let code = event.keyCode;
    let allowedKeys = [8];
    if (allowedKeys.indexOf(code) !== -1) {
      return;
    }

    onCompleteData({
      ...form,
      cardExpiry: form.cardExpiry
        .replace(
          /^([1-9]\/|[2-9])$/g,
          "0$1/" // 3 > 03/
        )
        .replace(
          /^(0[1-9]|1[0-2])$/g,
          "$1/" // 11 > 11/
        )
        .replace(
          /^([0-1])([3-9])$/g,
          "0$1/$2" // 13 > 01/3
        )
        .replace(
          /^(0?[1-9]|1[0-2])([0-9]{2})$/g,
          "$1/$2" // 141 > 01/41
        )
        .replace(
          /^([0]+)\/|[0]+$/g,
          "0" // 0/ > 0 and 00 > 0
        )
        .replace(
          /[^\d\/]|^[\/]*$/g,
          "" // To allow only digits and `/`
        )
        .replace(
          /\/\//g,
          "/" // Prevent entering more than 1 `/`
        ),
    });
  };

  const totalAmount = () => {
    let totalAmount;
    if (infoFile.detraction_detail !== null) {
      totalAmount = (
        infoFile.total_value - infoFile.detraction_detail.monto
      ).toFixed(2);
    } else {
      totalAmount = infoFile.total_value;
    }
    return totalAmount;
  };

  const paymentInvoice = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const validatePaymentForm = validatorPaymentForm(form, formError);
    if (validatePaymentForm) {
      onChangeError(validatePaymentForm);
    } else {
      onReset();
      generateCharge();
    }
  };

  const generateCharge = () => {
    const onSuccess = async (response: any) => {
      let amount = totalAmount();
      /*Arma el json request de la peticion */
      let body = {
        source_id: response.data.id,
        method: "card",
        amount: Number(amount),
        currency: infoFile.currency,
        description: `Cobro por ${companyInfo.legal_name} - ${infoFile.serie} ${infoFile.number}`,
        device_session_id: deviceSessionId,
        customer: {
          name: infoFile.receiver.legal_name,
          email: infoFile.receiver.email_address
            ? infoFile.receiver.email_address.split(";")[0]
            : "-@eximio.com.pe",
        },
      };
      setLoading(true);
      let { data } = await paymentService.paymentInvoice(
        infoFile.file_name,
        body
      );
      if (data.result) {
        toast.success("Transacción exitosa", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setTimeout(() => {
          setLoading(false);
          onClose();
          getData();
        }, 5000);
      } else {
        setLoading(false);
        toast.error(data.msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setTimeout(() => onClose(), 5000);
      }
    };
    const onError = (response: any) => {
      setLoading(false);
      toast.error(
        "Su transacción no fue procesada, por favor ingrese bien sus datos",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        }
      );
      setTimeout(() => onClose(), 5000);
    };
    window.OpenPay.setId(
      JSON.parse(companyInfo.credentials_openpay)[infoFile.currency][
        "merchantId"
      ]
    );
    window.OpenPay.setApiKey(
      JSON.parse(companyInfo.credentials_openpay)[infoFile.currency][
        "publicKey"
      ]
    );
    // window.OpenPay.setSandboxMode(window.OpenPay.getSandboxMode());
    window.OpenPay.setSandboxMode(true);
    const deviceSessionId = window.OpenPay.deviceData.setup(
      "payment-form",
      "deviceIdHiddenFieldName"
    );
    window.OpenPay.token.create(
      {
        card_number: form.cardNumber,
        holder_name: form.cardName,
        expiration_year: form.cardExpiry.split("/")[1],
        expiration_month: form.cardExpiry.split("/")[0],
        cvv2: form.cardCVC,
      },
      onSuccess,
      onError
    );
  };

  const chargeStore = async () => {
    setLoading(true);
    let expirationDate = paymentService.operationCharge(infoFile);
    let amount = totalAmount();
    /*Arma el json request de la peticion */
    let body = {
      method: "store",
      amount: Number(amount),
      currency: infoFile.currency,
      description: `Cobro por ${companyInfo.legal_name} - ${infoFile.serie} ${infoFile.number}`,
      due_date: moment(getCurrentDate())
        .add(30, "days")
        .format("YYYY-MM-DDTHH:mm:ssZ"),
      customer: {
        name: infoFile.receiver.legal_name,
        email: infoFile.receiver.email_address
          ? infoFile.receiver.email_address.split(";")[0]
          : "-@eximio.com.pe",
      },
    };
    let { data } = await paymentService.paymentInvoice(
      infoFile.file_name,
      body
    );
    if (data.result) {
      toast.success("Código de pago creado exitosamente", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      const { jsonCargo } = data;
      jsonCargo.logo = companyInfo.logo_path;
      jsonCargo.legal_name = companyInfo.legal_name;
      let res = await paymentService.paymentReceiptPDF(jsonCargo);
      if (res.data.size > 700) {
        setLoading(false);
        //Create a Blob from the PDF Stream
        const file = new Blob([res.data], { type: "application/pdf" });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window
        const pdfWindow = window.open();
        if (pdfWindow) {
          pdfWindow.location.href = fileURL;
        }
        onClose();
        getData();
      }
    }
  };

  React.useEffect(() => {
    setOpenModal(open);
  }, [open]);

  return (
    <Dialog
      open={openModal}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      style={{ zIndex: 99999 }}
    >
      <ToastContainer />
      <DialogTitle id="alert-dialog-title">
        <Tabs
          value={valueTab}
          onChange={handleChange}
          textColor="primary"
          indicatorColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          <Tab label="Paga con tarjeta" {...a11yProps(0)} />
          <Tab
            label="Paga con efectivo"
            {...a11yProps(1)}
            disabled={
              infoFile !== undefined
                ? infoFile.currency === "PEN"
                  ? false
                  : true
                : false
            }
          />
        </Tabs>
      </DialogTitle>
      <DialogContent>
        <TabPanel value={valueTab} index={0}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <div>
                <Cards
                  cvc={form.cardCVC}
                  expiry={form.cardExpiry}
                  focused={focus}
                  name={form.cardName}
                  number={form.cardNumber}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <TextStyle type="h4" bold={400}>
                  Transacciones seguras realizadas via:
                </TextStyle>
                <img src={logoOpenpay} alt="" style={{ width: 150 }} />
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <form
                action="#"
                method="POST"
                id="payment-form" /* onSubmit={handleSubmit} */
                style={{ paddingLeft: 20 }}
              >
                <InputNumber
                  name="cardNumber"
                  value={form.cardNumber}
                  onChange={onChange}
                  data-openpay-card="card_number"
                  onFocus={() => setFocus("number")}
                  placeholder="Número de la tarjeta"
                  maxLength={16}
                />
                <InputLetter
                  name="cardName"
                  value={form.cardName}
                  onChange={onChange}
                  data-openpay-card="holder_name"
                  onFocus={() => setFocus("name")}
                  placeholder="Nombre del titular"
                />
                <InputText
                  name="cardExpiry"
                  value={form.cardExpiry}
                  onChange={onChange}
                  dataOpenPayCard="expiration_month"
                  onFocus={() => setFocus("expiry")}
                  placeholder="Fecha de expiracion"
                  onKeyUp={handleKeyboardEvent}
                  maxLength={5}
                />
                <InputNumber
                  name="cardCVC"
                  value={form.cardCVC}
                  onChange={onChange}
                  dataOpenPayCard="cvv2"
                  onFocus={() => setFocus("cvc")}
                  placeholder="Código CVV"
                  maxLength={4}
                />
                <ButtonPrimary
                  background={Colors.GREEN}
                  color={Colors.WHITE}
                  size="20px"
                  onClick={(e) => paymentInvoice(e)}
                  loading={loading}
                  disabled={loading}
                >
                  {getCurrencySymbol(infoFile.currency)}
                  {totalAmount()}
                </ButtonPrimary>
              </form>
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel value={valueTab} index={1}>
          <TextStyle type="h4" bold={400}>
            Paga en bancos, agentes o tiendas de conveniencia en los que veas
            estos logotipos:
          </TextStyle>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <img
                  src="https://graffica.info/wp-content/uploads/2019/04/logo-bbva-05-1-1200x675.png"
                  alt=""
                  width="200px"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <img
                  src="https://www.america-retail.com/static//2020/12/bcp.png"
                  alt=""
                  width="200px"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <img
                  src="https://www.newrest.eu/wp-content/uploads/2016/01/Logo-Interbank.jpg"
                  alt=""
                  width="200px"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <img
                  src="https://www.newrest.eu/wp-content/uploads/2016/01/Logo-Scotiabank.jpg"
                  alt=""
                  width="200px"
                />
              </Grid>
            </Grid>
            <div>
              <img
                src="data:image/png;base64,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"
                alt=""
                style={{ width: 200 }}
              />
            </div>
            <ButtonPrimary
              background={Colors.GREEN}
              color={Colors.WHITE}
              size="14px"
              onClick={() => {
                if (
                  paymentService.hasCredentialsOpenPay(companyInfo, infoFile)
                ) {
                  chargeStore();
                }
              }}
              loading={loading}
              disabled={loading}
            >
              Crear código de pago
              {getCurrencySymbol(infoFile.currency)}
              {totalAmount()}
            </ButtonPrimary>
            <TextStyle type="h4" bold={400}>
              Transacciones seguras realizadas via:
            </TextStyle>
            <div>
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAiUAAABcCAMAAACGATX5AAABGlBMVEX///+mpqYudbcudbYudbXtfTGjo6Onp6dclMYpcrTn7/cgbbP8/Pz4+/0jb7Ofn5/Q0NCdvtxmmMnb5/J4pc/v9PrP3u09f7oWaLD09PR/qdHl5eXGxsa8vLywsLDt7e3b29vBwcFMhb1VjsPe3t6MsdapxeDI2uvV4/CvyeLA1OiWt9gAYq3xeymgqq/++fX3xKL4fSW3nYuuqqX75df1uZLzrX/rbQ7uhT3sdB71tovzrH3yoG33x6r/9exBh8bg0MeDeYDxklH51b2TeHWfem0AWqmmemetemEedMG9elX/fR7TfERWd5/XilrMkWi+mIDkgkJ6eIfTjFzHlHJCcqaqjYHewa+Bl6tbhrGMnKpvkK1SgrJ/nrwmJ6xrAAAWVklEQVR4nO1dC3frtpGWSOgBPmCJEkVatiVZst6287i9SW7SZrfb7W5vmk3a3Xa3abr//28sQIoSMYMHnWvLyVl+Jye+kkAQID7ODAaDQaNRo0aNGjVq1KhRo0aNGjVq1KhRo0aNGjV+DghVCF67VTV+RghHq/FwjLHfxaBk8NGrNLDG6yNeklQNFg3KBYNfvf3s41+9VjNrvCrG99RVwXGddOGdyn39cevzd5+33tby5P8hdr6jhqAJ7R/Lff32i5bAuy8r0CRscKMmyME/hOKPuiC3foITeMmGzR7Kfg7KF/GvnmJDhfF6u+2vom63u9j3+6vtdjeIQ/WNTncJG9pONIIwK34q2rD2oiKCS4Hp7U0v+8ermYpjRvRgUWGaFCRptR7e2toa9sl8Pl/2D9gP+aeupyi45j/MF+OiYH+8mM+TxUBR8oRRxK+JjpULDJN5Mq7Y3XC9XyTEIQ71GQflbwN/HZIkifarkVSyL9p2us9yMU+60FAr+puIjnSLwssu78ayVCCYXnFMC4gPV5fWpl7ygredzmQy6bTb7Uln0ul0etPpq1ClSzWyhIP4hcr5+suCJFyavLVUGS7vWTYEjHJkf9Kh4mWNF/lIlcCYvzNXPk7xNZT51MytQ8O8/kIUp1xKZkqVc4R/cPNKUplp+/J9+C140xaKTuT9pVJhjnRfLtFrdwDaU3NTp3ezTrMj6NE8gn/g9Uxms6uzE6XL9CxxC5Z89NmJJJwmH5urDPdpUUE+FLyiseIB92mpWFaUuM7KXPeAoouyD2xr76q3mvvl3rryXzaUW+eW7pMXiDT9XaZSk7L29MsleqWxzgd8YpAlQTDr3cAryri4np2ZJ1217ZqD5Yrio68+b5Xx+W+MVXKWEFCRv8TdGlF8a7ZUv65HLH0HXZTdILJcyPVblJr66gIS9GEfYIFTf5cpLEqohSU9bTM5R24v2iaS8Mub19dXtv4+J7pUa5UULPno1zJJOE2M0kSwRK7ISZeolNeFFhF/uJHKfClhwFWFoqFccZCNpaMrwvhbrrfBXDaXzA7OEmSlafq7TFFlVJKJ1VnCOTJpmily0D6dK601/fww2SU5S77+9bsWhFHpnDTO0cCR1XRWaIluzMfJYl0I2e7CyzJR71CLytmnlDiu6uICkCWoLMNUP7YK4iey5PKKm6p2jmToTKZno4mRJcIuUZGEz3QMSkfFkj4stGXyeLv8/SMWy7UxSLStZRrTsrhdZs+YSGJlCdXZPkqWSF1BLLmYqSoKppNORYpkmFSYKT0PDHaJQ/ijV5PESBPOElgVYsko4a92ycTg4p0SmwUaYAPg0FIuSxyTyhnwlyErp4dD55K668ul+cBTDYmxXeJQIknFaiwJriZV5UghTm4sU6Xngsl6Jf4//bOGJK2H1u908g5br0iWxEMmiFFmiZss1e6IEwaJfpiJb5gdhUtm4McBNJFGFlmvDl3rakfkpURiXCWWTM0TGyXaN+fROgaN4zrvf/tOQxKOf/mdpkrx1EBNKRAT+2zUZIEfWV0eS+AnLlfgsoWeZBuCe+lCBQTe/xUsT+lIXbtC4zAiNQaypKNgyeWNZWKDJcn5aKJliUs4SR4etCRpPehoomCJL7+Gu4RCrc8SK0nAWHONKA2yo69gjJxCGUlzX45L8tpcJrFgCx8MpRqdFo5hfznjLCy5g5VcPl2QdHJpcg7bRKdxCCfJv35iIIlemoRLH9Yms8Sbu1CcU0cjzkuA1TIq1ZLudfZrmCCFI2giXLb04DUVb4WsFuHduDDRswR1h0htsbMk0JFECJj8J12BmzMIEy1LGLORREcTzhLw1CgrP+BgyBzZwODvqcXnyjFyJVZQEklmikM1yyyNxjpFdiufUbnzaLnnGEeLJPF95srTdcQSIB9OiMforWCRkSXNJvSJ3So50G53Jr0CYjlHNQVq3748TTQax/XZ760kaT38+mtFlVjj0KRkzAUrvCigXOcBGEtzZ+GmlRQJH3mN3dDY3hNwP25kjHfHNsWD9Wo8p/8m+UOQEcQSTfXxEGkc4FqBLGlfyzUE0xslSSa90lz38q6nngNNXn6io2aJy6qQpNV6p5oPcwkMH1rZXTaaw5u5p7VnPTZOqaWEE2/U6EsDqVwGyNqz57IN9nAL7hgOdkPpemSS0rmmZQqW0L1RlrSv5ZZOlfpm0oOW6bSn9Ke8PE2Qhz6Tx+/dSiRpvftKUWU49KG/usSSOPLhHa0+V1HpmJ085txw9YdxY5NKXnSq4VoYMeH9L9/RV7lRY6kVY7mZLqe6pmkx7C8hrP8UlgQzBUnaE8XSb3CnEieGVaFnArJLnIwk/16JJK13XyqqDIfQWCyxRGXqJTafK8dGWht0CBPXLOQbOep6Qmx7pXZbGRobepZ4EbTDOEukEbaw5GqikA+36rnLpYomLy5MkMbhnXzv/OGPlUjSainN16EvS2CXnUKLdnyEgZWQ9u3mF5dPQPwLuQGWAnx1LFIoFpLBLe28HCO7ZKEpyVkCNY6/egJLVAM/6ekmuEqazKzd+TB0geeCS+b37h/+WI0jLWV4YwhjVlz/aJwOiLyewicbVSzXxppITjjiZ266ke+WnWMsUS8pr1Jovab2KRVkicN08XBegsxx4Ag2s+QOGxsmL4hY7OmASzov7DSB0pi478k31dRNq/WVMqQ+hg5rcmSJFwFlRIhfwXIVxgxQYRkfwoXces3C8BrPVA2O2gOA2uTWk44lA0WcjCyrIEsuyoZEoBIlBhUSKFjVeWGVg3Q2S775pBpHvlCTBLPETcf5uxMsZQUuVukqWK58LiuEQelCP3eABWM5KImpxVKcMGA4OD5apIYYytTiGmeoKTlC/XXA0qORJZfYKmnPTC27VDhXei/rM0F2Camsbj7TbM7x0MSwCCnd4fWURYVQRC5KgEwv3Pk7uT4xPVYghIaSYJztvhGyS3TEGuHAAXm1IAAs6UgswbNbmzv1DrHEGCH5DIAsYb+tarh+pfKoCXjwqbmHULUNf6el74nDKliueOXtaKZ6c1b2tDkaF67ka8mLUkvYUrwAxCTa0No1ZokrC0gjS7CvxCxKOOtukSx5cZZIE33nr9+W9M2DgE6S6EjCWQLdBzlLvGFmHJduplMRsMJIbuRpjT/k89WyT0MT5h4ugVfIFYHzfdO94zkKuIyGaqiCQiUzOrg2sCRACse+MoM9/i88Fway5P1/lIjw0Pru+++/VfLkQU+SxkAjS/pwDuzql14kQJc+O0Xk78o1ukS3bjuYyzpH2A6UjQ1RtvEcaBxOTqaAn23qQbJEqvnqQlYqEkt6F4glVifZFRY/N9an+CGQWeJylhxJ8fDtp4+Pj80//Rnz5OGtniScJcguESzZZZtgyl/TxO7camTGp8yt5ESFwVzeO6EIw87AlZ1ME0EUFunv783h9FYX6oY5wjsmsd/Ikms04vYJC54WnZclTvJdoXEe/vzmkffu8fHN9y046zGRpDFAtqKwATZi1io/9gpeC4G+X44k4bqitLkHGqZgfE7YKUJmCUl2OuGOWWIJm5VaKCs+zJLZ6UfMkondVEMXvXD8AJgJO+w/C2fJw58e8xY8Pn4qqx2jJOF8gDNDSkaNeIj3t6i2cmF4hDpybWUJsAIOGJ1XNRCRTzLEegtZaVjlzY2bd0wgJS9ihqexBC4FqnB+lsjvAXV+n8+EP/mvTicPh2p2Hpt/+eKhRBLzhvIRDhwYNfqUgneRzS2bb3IEIopWqm1cHlgYwKb15AY7F85asqARjXGikiVV4fpLI0ukGQke8AprdwqWvOgkB86E+YBkDpOHL948nhrBxcl3R3FiS04xgr5tYUiMqQPc5GBngw4DEP3IZGMmBDNWnZe+IZQOU+gMpt6+PsBu96ogxN8bWVJ+8XGQmnoXhozzswSKy/fkG06Th788Ss3gVuwXmS56Z81gssKrqWux1wEI5gr+T4Gl78ohafORV0IcgT2hBmNnnci6MI9+ZcptQJuEmvZlmMAFmuwFMrEEyZlqLAHXnJ0lDhE0+eTbpswSrnaEFftg2q51wB4um/CBbTS2Dnzq1NEFl5WwgbsriEh7UQIcI2rYvjXoqkaeqfxlA2TGVAZiyd3zs+R17ZJ8UZh88/DpI3IcZ1bsb+yt2cM5DhMsCYdIhOvChkoIYWChcJWX01LgmYtu24yAt1SpCEq2iFkjw55HC1wC5NndhX5If6Es4SDv//rfytC5x4v/qdCYPYPhJXPh4MDbN127zlnjPRk2MLQnuQRvTylBPg6WIJqsgGswW5pUyQ28+RhpPRiKZmRJx+afF1CwxH7RB0AZQ88SLEnyxlxXUH97GB1AM5Y0VgTpnMSSKSBcwtVcO8xzp7jv4h5z+xoqnRVe6KVKiG0aoL8O2KRmYkkAF3g7FeY4AQqmfgWWOPRvb5Qk4ejZEyLA7ZYklyUiuEQaciFlLDpnR55qHRDi6PbzHrAlFDMPuYH7KEgm0QLtFX0CS1QzYau8Vnjor23XfBBUGsf/AcZClZpj78QSBjQWgUY7mGeAy3qjzgmHFEaZWeFqM0gU2BFs67hwBt1HIfTRerQeif8E1of/r9fr0S4CKpZ8EEuadhMDR1NX8Nd+CDBLhL7RihKB65m5yiW0SwpXpNiCAZW4cSlHm0DSCGtIvtjrgdgHgmYxS7TL12gHKEnlydsTWWKNAsAK58yRA/zhUV+vb/JOdm6M+d8iuOZ+TGcVL1AqI5NvLZwzReYjO6wRRpuhCHSRL6KupKj2qXxrlw51DY3BpgzHSWVzy8gSvCbcsRkmV3hIXlyWAPXr+v/o6BVO0ShDfpVgAe2SU9IzbBO6qX41Z6tJV2IBsSdZ88bYKmZjedMWsDX0oTBiP45U1AGyBAVHm1lis0SDXhOOTwftTn9eII3D3L+/aaJmIL7r0zXFcMbLNU7xWwhDE4UZoTM2w8VP9FmAHBPKRg7RDFu6KsQh9FqW4J0Wsiy5hA+zfVv6VbGPvG0ec0UynJePjoZP44c3VdI2tW9mmpZ5MLi1xBKRAwmswOtnrluwzKdNZYRogtO4IWyQI0ZKsuKhDKcGWQJY4lJfYukUrdRIExLF7k+ju/3yGo/PS+cdgHaJzXQt8eRWnXXUS2AmxBJLgqWIMoE/qyPfuREjlRSpzZThYtjYMSdZy9BHEYvlCCZvgXax6mXJnIKiFpbI01bV3l/TPLKHSndQCoPnBrRL6A8VSSImxdeqdNce9EeUWZLFMyNDQmltrqB3hZC5SB6PsUCZtJh9hWjDoDOsvDPIg8aVIUR3A3PQUlnjWFgSTLCZcaNP+ztTjMSLZ7pBMfQ/VmZJ5orFvRkQuF1QmmRufewgV+WUGCQURskm61iJNbCE+IDb89IP0BKQXzrCw4Mh9AaNM7oHRanse5nCxyZrHNUurOZERxPVxvMqKz8fBsgS+hSWNJuKDCsDlCxEGrMYJ3oldIhNkz7eVqnzloWRD+5JT/Pr9S5UDu8a11+SJQMUhGRgSYrWrWSWmO2SxlSxmbw5Ua6FXGJ1U3HZ5MMA7RI6bz6FJopFhw1xgJ0gv9kiiacEMarI3NzAUlwlaBd9VlRKUSFG/KjEdn60H8SIzPGQQfNJskvQ7fXJz0dwZwmVA5sssoQLE+WTvbmDjQ6ubpTJkGa65/JsgHaJECZPoMmFiiXQ7JBZEsD4k2wPFXDBBnDJ0NXv5s4pVS4qrIjiEe9cxkjUX3vlM3DiTQTNEjkp7QZZT/rzENYozldmCXKCAZZwYaJKctNu31yVFHpweaWY3Ai88O5PAeyhpz82K82FM0ywdb1GK+ngTJHMgC3/7uDwRjhRFR/068fhkAGV47pF6WzBkKXpfLzc7jZi4WWz6w9VUa3lTJ3be2Q8aVmyQ6mfZJYguwOyRJnARPCE653iWJ2r3o06X1bnDCTBa8KEsn/8vao4kfxDB/RRKKAP9MlWEQ0gl0FpfInjjw1PY4uWjlkR4rE5TKo4UdJ7RyzhumnqK6IHWHmTBmcJaIBvYgmo6aksCTQ0abYvxClKGS40ORo75zhWCW1f5OKf0R8eq4kTxcbDYA/dFyi/PEqplRkv5VHI4hgls4Aykz91AM0I4hfbBuNFyTGSh4TgmwtI0UucJab2SdjCIzyezBIcZXLkQH54UlvrDT+DUdJQZcwScw4/+dubCjxR7k7tAzHg4FMIBjhsRDb5sgTkUiX+0PjKjKGZ4RQJZMNu2Z2h26HH1YSUJ2B7D8N0tYeAoQTjT5cl6iQmVdCZmZ7Ks0GZo1Fsoq2gdtSB23sGHCKKsypwNCuflpymmrvUhem/dem9D9ii9aFCNOClIxVcVw6EXEEfiJklJrsEE0DBksbljUbpGAfgPJJEnxXYYeTHtkWcqE9UGCJXJGaJt8BvtEOLZGQhzJjEW2NZ5h0ksDp28JGF3QonFZyKH1rQRwcuGFgCk+8BlqATb1QsEUfjPFWcdG5mxofyfNCftcWEODEyGU3oM4gNMrJdoog0WkGfCoezOMgLEdMm/2TLNpLNckBtRWAj+kXZWZnJ8dBHdomWJWNoZUGWwAenZMnTDz5pazP0PTt0pxVk0wr6vz2Vs+/QSHWuyXgBMyLKG3tzeCo9cIiChWusp18MWEEH6DHKRJGqGoGCJKAezIRk0jgo05LMEhQ4oGEJp4k66a/u+V+f70g2yxmgceNKwxMNSRQbbFUsaexcxWEkufcThseK527NTiCcpWAf8iEXDjqcQrpltoeCwYBqD4aycjtHF3oZo5SUP5ElOi+s5vGf83hHFH5YktkkU9aXGoZruuqhJELKbGchPu5aBMqtxRIKhbEF1HbqY76WA3VE7kvdGqIiRci9w/wudNh5XaxxdCwZwLDLn84SXrjK4Y7tdudMpycVQN4NqbtZrGdwiSN49ZvJsOtCvetmRJxioA4QcWvzMEuZBEfIHlUU9u+FMSNlHM/TdW71p5wK6eP7Cc5OIbKqVWXJBgWqfABL+MPuZR40wyaGzuTMHFEtfpZURaGtgx4+CEoXwrvJNusz5megmehXzmIPE0hWFPVFPIk/3iZMnFxTfCcqoPYTlrKsKaI2/3il4+QW6Zbdp3lDUJ4al6Xuoq+QU55YIGCnmji0LBmJ32mpLGDJNPOLXRyQ/du8eYa/lbeTi7bi6C1+6c3t7d0Zj4gtsGWa7Qx8BntaBoWHyulXD3Ys9VPSjXIkfIBS9c5dz03Fc11EUamsf5+Ky4/fdbMKLBtsMsQkTVMm1Xbfze6zW42HUZKNYXZkUvYC5EFu3eVOScANJ1Y6P9S0YKJhqf5cFT9Nk6K9lF94L7F6es1xPOWmJz7NbJ0Jprzk7cXB7Xrwv7Y7/MvLV6CIwDpiPo4S5JiXJTFYatCH43piO9OgSBwxyHY3qX0dg2zrUynLxKjA4PSdqGBTKR1OXlK+8PBTHHuD9W67HA6HUeT6zHejaDjc7zaexgsTSy3bGDqh7PCmXDYQ0H40ILibZZi0e9nfu2njdRiSIR6oAYIypqVTNzr6iLufMcIwjOPQy/rG/1EpX9fPAMHZ3CLPgeB4cHZ79otqeI2zIpjlh2d3zjlXr/FLQxD0hBVl3ABao0Yw6/VqSVLDhleaitWoUaNGjRo1atSoUaNGjRo1atSoUaPGa+L/APPREktzm9NKAAAAAElFTkSuQmCC"
                alt=""
                style={{ width: 150 }}
              />
            </div>
          </div>
        </TabPanel>
      </DialogContent>
    </Dialog>
  );
};

export default ModalPayment;
